import CustomLinksCell from "./CustomCells/CustomLinksCell";

export default function VorTableColumns({ upperFuncs }) {
	return [
		{
			name: "num",
			title: "№ п/п",
			width: "48px",
			cellHorAlign: "center",
			headHorAlign: "center",
			headHeight: "30px",
			marginLeft: "0px",
			headCustomStyle: { paddingLeft: "1px" },
			cellCustomStyle: { paddingLeft: "5px" },
		},
		{
			name: "name",
			title: "Наименование работ, ресурсов, затрат по проекту",
			width: "auto",
			cellHorAlign: "left",
			headHorAlign: "left",
			headHeight: "30px",
			marginLeft: "0px",
			colSpan: "2",
		},
		{
			name: "unit",
			title: "Ед. изм.",
			width: "60px",
			cellHorAlign: "center",
			headHorAlign: "center",
			headHeight: "30px",
			marginLeft: "0px",
			headCustomStyle: { paddingLeft: "5px" },
			cellCustomStyle: { paddingLeft: "5px" },
		},
		{
			name: "quantity",
			title: "Объем работ / Количество",
			width: "100px",
			cellHorAlign: "right",
			headHorAlign: "center",
			headHeight: "30px",
			marginLeft: "0px",
			headCustomStyle: { paddingLeft: "5px" },
			cellCustomStyle: { paddingLeft: "5px" },
		},
		{
			name: "quantityformula",
			title: "Формула расчета объемов работ и расхода материалов, потребности ресурсов",
			width: "300px",
			cellHorAlign: "left",
			headHorAlign: "left",
			headHeight: "30px",
			marginLeft: "0px",
			colSpan: (rowObj) => {
				if (rowObj?.colSpan && rowObj?.colSpanTarget === "quantityformula") {
					return rowObj.colSpan;
				} else {
					return 0;
				}
			},
		},
		{
			name: "_links",
			title: "Ссылка на чертежи, спецификации в ПД",
			width: "150px",
			cellHorAlign: "left",
			headHorAlign: "left",
			headHeight: "30px",
			marginLeft: "0px",
			cellJsx: ({ rowObj, funcs }) => <CustomLinksCell rowObj={rowObj} funcs={funcs} upperFuncs={upperFuncs} />,
		},
		{
			name: "comment",
			title: "Дополнительная информация (комментарий)",
			width: "300px",
			cellHorAlign: "left",
			headHorAlign: "left",
			headHeight: "30px",
			marginLeft: "0px",
		},
	];
}
